import React, { FC } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useNavigate } from 'react-router-dom'
import { BlankLayout } from '../../components'
import constants from 'utils/constants'
import { routes } from 'config'

const NoAccess: FC = () => {
  const { authState, oktaAuth } = useOktaAuth()
  const navigate = useNavigate()

  // add session storage item to tell /home page that user is trying to get to app that he has no access to
  // /home page will route correctly based on it if other checks pass
  sessionStorage.setItem(constants.BROWSER_STORAGE_KEY.HAS_NO_ACCESS, 'true')

  if (!authState?.isAuthenticated) {
    const tokenParams: any = {
      scopes: ['openid', 'email'],
    }
    oktaAuth.token.getWithRedirect(tokenParams)

    // once authenticated, it will redirect to /home automatically
  } else {
    navigate(routes.home)
    return null
  }

  return <BlankLayout />
}

export default NoAccess
